<template>
    <form
        class='form-dr'
        @submit.prevent="handleSubmit" id="payment-form"
    >
        <InputTextField
            :vuelidate="v$.formData.name"
            id="name"
            label="First Name"
            :value="state.formData.name"
            @input="(e) => setInput(e, 'name')"
        ></InputTextField>
        <InputTextField
            :vuelidate="v$.formData.last_name"
            id="last_name"
            label="Last Name"
            :value="state.formData.last_name"
            @input="(e) => setInput(e, 'last_name')"
        ></InputTextField>
        <InputTextField
            :vuelidate="v$.formData.email"
            id="email"
            label="Email"
            :value="state.formData.email"
            @input="(e) => setInput(e, 'email')"
        ></InputTextField>
        <PasswordField
            :vuelidate="v$.formData.password"
            id="password"
            label="Password"
            :value="state.formData.password"
            @input="(e) => setInput(e, 'password')"
        ></PasswordField>
        <button v-on:click="handleSubmit" type="submit">Register</button>
    </form>
</template>
<script setup>
import {ENV_URL} from '../../environment.js';
import axios from 'axios';
import InputTextField from "../fields/InputTextField.vue";
import PasswordField from "../fields/PasswordField.vue";

import { email, required, requiredIf, numeric } from '@vuelidate/validators'
import {useVuelidate} from "@vuelidate/core";
import {computed, reactive} from "vue";
import {useStore} from "vuex";

const state = reactive({
    formData: {
        name: '',
        last_name: '',
        email: '',
        password: '',
    },
})

const notRequired = () => true;
const rules =  {
    formData: {
        name: { required },
        last_name: { required },
        email: { email, required },
        password: { required },
    },
}

const v$ = useVuelidate(rules, state);

const store = useStore()

const setInput = (e, field) => {
    state.formData[field] = e.target.value;
}

const loading = computed(() => store.state.loading)

const handleSubmit = (e) => {
    if (loading.value || v$.value.$invalid) {
        v$.value.$touch();
        return;
    }
    store.dispatch('LOADING', true);
    // Send the data to the server
    let uri = ENV_URL + '/users/createUserRequest';
    axios.post(uri, {formData: state.formData}).then((response) => {
        const return_data = response.data;
        if (return_data.error === false) {
            localStorage.setItem('laravelAuthToken', response.data.laravelAuthToken);
            store.commit('SET_USER', response.data.user);
            store.dispatch('TOGGLE_LOGIN_POPUP');
            alert('Your account was created successfully!');
        } else if (return_data.error == true) {
            if (return_data.error_type == 'email_exists') {
                alert(return_data.message);
                state.email_exists = true;
            } else {
                alert(return_data.message);
            }
        }
    }).catch(function (error) {
        console.log(error);
    }).finally(() => {
        store.dispatch('LOADING', false)
    })
}
</script>